'use strict';
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const returnFocus = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open);
      if (dialog && !dialog.open) { returnFocus.set(dialog, opener); dialog.showModal(); opener.setAttribute('aria-expanded', 'true'); }
    }
    const closer = event.target.closest('[data-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  function init(root = document) {
    root.querySelectorAll('dialog').forEach(dialog => {
      if (initialized.has(dialog)) return;
      initialized.add(dialog);
      dialog.addEventListener('close', () => {
        const target = returnFocus.get(dialog);
        if (target?.isConnected) { target.setAttribute('aria-expanded', 'false'); target.focus(); }
      });
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', () => dialog.close()));
    });
    root.querySelectorAll('.hero').forEach(hero => {
      if (initialized.has(hero)) return;
      initialized.add(hero);
      const video = hero.querySelector('video');
      if (!video) return;
      video.muted = true;
      const syncFilm = () => {
        if (motion.matches) video.pause();
        else video.play().catch(() => { /* Autoplay unavailable: retain the native poster. */ });
      };
      motion.addEventListener('change', syncFilm);
      hero._cleanup = () => { video.pause(); motion.removeEventListener('change', syncFilm); };
      syncFilm();
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const select = section.querySelector('[data-variant]');
      const quantity = section.querySelector('[data-quantity]');
      const add = section.querySelector('[data-add]');
      const stock = section.querySelector('[data-stock]');
      const price = section.querySelector('[data-price]');
      const gallery = section.querySelector('.gallery-stage');
      const slides = [...gallery.children];
      const dots = [...section.querySelectorAll('[data-slide]')];
      const moveTo = (index, behavior = motion.matches ? 'instant' : 'smooth') => gallery.scrollTo({ left: slides[index]?.offsetLeft - gallery.offsetLeft, behavior });
      dots.forEach((dot, index) => dot.addEventListener('click', () => moveTo(index)));
      gallery.addEventListener('scroll', () => {
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        slides.forEach((slide, i) => { if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause()); });
      }, { passive: true });
      function update(changeURL = false) {
        const variant = variants.find(item => item.id === select.value);
        if (!variant) return;
        const minimum = variant.min || 1;
        let maximum = variant.max == null ? null : Math.max(0, variant.max - variant.inCart);
        if (variant.inventoryManaged && variant.deny === 'deny') {
          const remaining = Math.max(0, variant.stock - variant.inCart);
          maximum = maximum == null ? remaining : Math.min(maximum, remaining);
        }
        quantity.min = String(minimum);
        quantity.step = String(variant.step || 1);
        if (maximum == null) quantity.removeAttribute('max'); else quantity.max = String(maximum);
        quantity.value = String(minimum);
        const unavailable = !variant.available || (maximum != null && maximum < minimum);
        add.disabled = unavailable;
        add.textContent = variant.available ? 'Add to bag' : 'Sold out';
        stock.textContent = !variant.available ? 'Sold out' : unavailable ? 'Maximum quantity already in your bag.' : 'Available to order';
        price.replaceChildren();
        if (variant.compare) { const old = document.createElement('s'); old.textContent = variant.compare; price.append(old, document.createTextNode(' ')); }
        price.append(document.createTextNode(variant.price));
        if (changeURL) {
          const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
        }
        const index = slides.findIndex(slide => slide.dataset.mediaId === variant.media);
        if (index >= 0) moveTo(index, changeURL ? undefined : 'instant');
      }
      const optionBlocks = section.querySelector('[data-product-options]');
      const optionControls = [...section.querySelectorAll('[data-option-index]')];
      const syncOptions = () => {
        const variant = variants.find(item => item.id === select.value);
        if (variant) optionControls.forEach(control => { control.value = variant.options[Number(control.dataset.optionIndex)]; });
      };
      optionControls.forEach(control => control.addEventListener('change', () => {
        const index = Number(control.dataset.optionIndex);
        const current = variants.find(item => item.id === select.value);
        const desired = [...current.options];
        desired[index] = control.value;
        const candidates = variants.filter(item => item.options[index] === control.value);
        const exact = candidates.find(item => item.options.every((value, i) => value === desired[i]));
        const next = exact || candidates.find(item => item.available) || candidates[0];
        if (!next) { syncOptions(); return; }
        select.value = next.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const status = section.querySelector('[data-option-status]');
        if (status) status.textContent = exact ? '' : 'Available combination selected: ' + next.options.join(' / ');
      }));
      select.addEventListener('change', () => { syncOptions(); update(true); });
      syncOptions();
      if (optionBlocks) {
        optionBlocks.hidden = false;
        select.hidden = true;
        section.querySelector('[data-native-variant-label]').hidden = true;
      }
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.hero').forEach(hero => hero._cleanup?.());
    event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
  });
})();
